const ROSE = ({ ...props }) => (
  <svg
    width="120"
    height="120"
    viewBox="0 0 120 120"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M107.825 23.7678C98.7411 12.1461 85.4076 4.79101 70.6627 4.79101C42.1457 4.79101 21.2823 31.2912 21.2823 59.9998C21.2823 80.0132 34.564 94.9901 49.3391 94.9901C50.7193 94.9901 52.0893 94.8651 53.4393 94.6166C43.5441 87.3996 37.2123 74.2547 37.2123 59.9998C37.2123 37.3012 52.5673 19.6128 70.6627 19.6128C90.3976 19.6128 104.121 39.2112 104.121 59.9998C104.07 75.3532 98.5961 90.6181 88.9641 101.882C80.5577 111.714 69.6692 117.949 57.6973 119.927C57.6973 119.927 58.6958 120 60.0008 120C93.1376 120 120 93.1366 120 59.9998C120 46.3863 115.463 33.8345 107.825 23.7678ZM98.7171 60.0003C98.7171 39.9852 85.4356 25.0085 70.6622 25.0085C69.2802 25.0085 67.9122 25.1335 66.5602 25.3835C76.4572 32.6002 82.7872 45.7453 82.7872 60.0003C82.7872 82.6987 67.4337 100.387 49.3386 100.387C29.6018 100.387 15.8801 80.7887 15.8801 60.0003C15.9301 44.6469 21.4051 29.3818 31.0352 18.1184C39.4435 8.28672 50.3318 2.05168 62.3022 0.0733337C62.3022 0.0733337 61.3052 0 60.0003 0C26.8635 0 0 26.8635 0 60.0003C0 73.6122 4.53669 86.1636 12.1767 96.2341C21.2585 107.852 34.5935 115.209 49.3386 115.209C77.8557 115.209 98.7171 88.7086 98.7171 60.0003Z"
      fill="black"
    />
  </svg>
);
export default ROSE;
